import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '@ahafood/ui/components/card';
import { Separator } from '@ahafood/ui/components/separator';
import StoreItem from '../../../components/store-item/store-item';
import type { Item, ItemType } from '@/api/use-get-menu-order';

interface MenuItemsProps {
  itemTypes: ItemType[];
  itemTypeRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
  onItemClick: (item: Item, index: number) => void;
}

export function MenuItems({
  itemTypes,
  itemTypeRefs,
  onItemClick,
}: MenuItemsProps) {
  // Calculate global index across all item types
  let globalIndex = 0;

  return (
    <div className="md:space-y-6 pb-20">
      {itemTypes.map((itemType) => (
        <Card
          className="overflow-hidden relative border-none rounded-none shadow-none md:border md:rounded-lg md:shadow-sm"
          key={itemType._id}
          ref={(el) => {
            itemTypeRefs.current[itemType._id] = el;
          }}
        >
          <CardHeader className="p-4 w-full md:p-6">
            <CardTitle className="line-clamp-1 md:text-xl md:font-semibold py-1">
              {itemType.name}
            </CardTitle>
          </CardHeader>
          <Separator className="mx-4 w-[calc(100%-2rem)] md:mx-6 md:w-[calc(100%-3rem)]" />
          <CardContent
            className="grid grid-cols-2 gap-4 p-4 md:grid-cols-4 md:gap-6 md:p-6"
            data-testid="store-detail-item-section-grid"
          >
            {itemType.items.map((item) => {
              const currentIndex = globalIndex++;
              return (
                <StoreItem
                  key={item._id}
                  item={item}
                  onClick={() => onItemClick(item, currentIndex)}
                />
              );
            })}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
